import React from "react";

import {
  getCenterNodeInitials,
  getCenterUserEmail,
} from "./relationshipGraphUtils";

/**
 * Hover card shown when the user hovers the center node in relationship graphs.
 */
export default function GraphCenterHoverCard({
  visible,
  centerUserStakeholder,
  initials,
  nameFallback = "You",
  translateYOffset = -32,
}) {
  if (!visible || !centerUserStakeholder) return null;

  const centerDisplayName = centerUserStakeholder?.name || nameFallback;
  const centerTitle = centerUserStakeholder?.title || "";
  const centerEmail = getCenterUserEmail(centerUserStakeholder);
  const displayInitials =
    initials || getCenterNodeInitials(centerDisplayName, nameFallback);

  return (
    <div
      style={{
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: `translate(-50%, -100%) translateY(${translateYOffset}px)`,
        zIndex: 60,
        background: "#fff",
        border: "1px solid #e2e8f0",
        borderRadius: 12,
        boxShadow: "0 4px 24px rgba(0,0,0,0.13)",
        padding: "14px 16px",
        minWidth: 220,
        pointerEvents: "none",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 10,
          marginBottom: centerEmail ? 10 : 0,
        }}
      >
        <div
          style={{
            width: 44,
            height: 44,
            borderRadius: 10,
            background: "#1e293b",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff",
            fontSize: 14,
            fontWeight: 700,
            flexShrink: 0,
          }}
        >
          {displayInitials}
        </div>
        <div>
          <div
            style={{
              fontWeight: 700,
              fontSize: 14,
              color: "#111827",
              lineHeight: 1.3,
            }}
          >
            {centerDisplayName}
          </div>
          {centerTitle ? (
            <div style={{ fontSize: 12, color: "#6b7280", marginTop: 2 }}>
              {centerTitle}
            </div>
          ) : null}
        </div>
      </div>
      {centerEmail ? (
        <div
          style={{
            fontSize: 12,
            color: "#374151",
            display: "flex",
            alignItems: "center",
            gap: 6,
          }}
        >
          <span style={{ color: "#9ca3af" }}>✉</span> {centerEmail}
        </div>
      ) : null}
    </div>
  );
}
